import { GroupClassRegistrationModalTestID } from "@/constants/TestID";
import type { FAIconName } from "@/ui/core";
import { Icon, Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface RecommendedGroupDismissLinkProps extends ViewWithTestID {
  dismissIcon: FAIconName;
  dismissText: string;
  onDismiss: () => void;
}

// icon + text "dismiss" link shown beneath the register button in the recommended-group
// modal, shared by the v1 actions bar and the v2 sections view.
const RecommendedGroupDismissLink = ({
  dismissIcon,
  dismissText,
  onDismiss,
  testID,
}: RecommendedGroupDismissLinkProps) => (
  <HStack
    alignItems="center"
    gap={6}
    justifyContent="center"
    onPress={onDismiss}
  >
    <Icon
      color={ColorToken.Primary100}
      name={dismissIcon}
      size="sm"
      testID={joinTestIDs(
        testID,
        GroupClassRegistrationModalTestID.dismissIcon,
      )}
    />
    <Text
      color={ColorToken.Primary100}
      testID={joinTestIDs(
        testID,
        GroupClassRegistrationModalTestID.dismissText,
      )}
      variant="body"
    >
      {dismissText}
    </Text>
  </HStack>
);

export default RecommendedGroupDismissLink;
